var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('div',{staticClass:"card-body card-deck flex-column flex-xl-row"},[_c('permissionables-card',{on:{"item-selected":_vm.itemSelected}}),_c('permissions-card',{attrs:{"selectedItem":_vm.selectedItem,"selectedItemType":_vm.selectedItemType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }